import { pxToRem, pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';
import { Box, Typography } from '@mui/material';
import { IStyles } from '@geneo2-web/shared-ui';

interface ITimerWithMinSecProps {
  timer: number;
  totalTime: number;
}

export const TimerWithMinSec = (props: ITimerWithMinSecProps) => {
  const { timer, totalTime } = props;

  // ------------------------------------------------------------

  const getTimeColor = () => {
    const percentage = (timer / totalTime) * 100;
    return percentage < 33
      ? '#FF0000'
      : percentage < 67
      ? '#FFBF00'
      : '#0AA34F';
  };

  // ------------------------------------------------------------

  const styles: IStyles = {
    root: {
      display: 'flex',
      justifyContent: { xs: 'center', md: 'flex-end' },
      alignItems: 'center',
      mb: { xs: pxToRem(16), md: pxTovW(20) },
    },
    timerBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      border: `2px solid ${getTimeColor()}`,
      borderRadius: { xs: pxToRem(8), md: pxTovW(8) },
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      padding: { xs: pxToRem(5), md: pxTovW(5) },
      minWidth: { xs: '30%', md: pxTovW(180) },
      boxSizing: 'border-box',
      gap: { xs: pxToRem(10), md: pxTovW(10) },
    },
    digitTextBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: { xs: pxToRem(5), md: pxTovW(5) },
    },
  };

  // ------------------------------------------------------------

  return (
    <Box sx={styles.root}>
      <Box sx={styles.timerBox}>
        <Box sx={styles.digitTextBox}>
          <Typography
            variant="bodyText"
            fontWeight="bold"
            color={getTimeColor()}
          >
            {Math.floor(timer / 60)
              .toString()
              .padStart(2, '0')}
          </Typography>

          <Typography variant="bodyText">min</Typography>
        </Box>

        <Typography variant="h2">:</Typography>

        <Box sx={styles.digitTextBox}>
          <Typography
            variant="bodyText"
            fontWeight="bold"
            color={getTimeColor()}
          >
            {(timer % 60).toString().padStart(2, '0')}
          </Typography>

          <Typography variant="bodyText">sec</Typography>
        </Box>
      </Box>
    </Box>
  );
};
